import { render, staticRenderFns } from "./phoneRecharge.vue?vue&type=template&id=6be74067&scoped=true&"
import script from "./phoneRecharge.vue?vue&type=script&lang=js&"
export * from "./phoneRecharge.vue?vue&type=script&lang=js&"
import style0 from "./phoneRecharge.vue?vue&type=style&index=0&id=6be74067&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be74067",
  null
  
)

export default component.exports